import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
//Redux
//Components
import { FiSearch, FiArrowRight } from "react-icons/fi";
import { Button } from "@delibrandev/utils";
import { GeneralInformation } from "./pages/generalInformation";
import { UsersAndPermissions } from "./pages/usersAndPermissions";
import { PaymentsMethods } from "./pages/paymentsMethods";
import { DeliveryMethods } from "./pages/deliveryMethods";
import { Domains } from "./pages/domains";
import { Policies } from "./pages/policies";
//Functions
//Styles
import "./style.css";
import "./sections-v4.css";
import "./reference.css";
import { Printers } from "./pages/printers";
import { AdvancedConfiguration } from "./pages/advancedConfiguration";
import {
  LuInfo,
  LuUsers,
  LuPalette,
  LuCreditCard,
  LuTruck,
  LuGlobe,
  LuFileText,
  LuPrinter,
  LuSettings,
  LuChefHat,
  LuReceiptText,
  LuClock,
} from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { setConfigurationSearch } from "../../../../reducers/userConfigSlice";
import { Design } from "./pages/design";
import { PointInvoice } from "./pages/pointKds";
import { BillingSettings } from "./pages/billingSettings";
import { Schedule } from "./pages/schedule";

export const ConfigurationPanel = ({
  title,
  description = "",
  className = "",
  content,
  hasButtonSave = true,
  action = () => null,
  textButtonAction = "Guardar",
  iconButtonAction = <></>,
}) => {
  return (
    <div className={`adminPanel mb-2 h-auto ${className}`}>
      <div className="configurationPanelContentTitle">
        {description ? (
          <div>
            <h2>{title}</h2>
            <p>{description}</p>
          </div>
        ) : (
          title
        )}
        {hasButtonSave && (
          <Button
            key={"Save"}
            text={textButtonAction}
            icon={iconButtonAction}
            action={action}
            customClass={"customButtonColor2"}
          />
        )}
      </div>
      {content}
    </div>
  );
};

export const Configuration = () => {
  const [selectedButton, setSelectedButton] = useState(100);
  const [legacyTerminalLink, setLegacyTerminalLink] = useState(false);
  const [content, setContent] = useState();
  const dispatch = useDispatch();
  const search = useSelector(
    (state) => state.aplicationConfig.userConfig?.configurationSearch || "",
  );
  const setSearch = (value) => dispatch(setConfigurationSearch(value));

  const handleMenu = (option) => {
    setLegacyTerminalLink(false);
    setSelectedButton(option.id);
    setContent(option.content);
    const nextHash = `#${option.id}`;
    if (window.location.hash !== nextHash) window.location.hash = nextHash;
  };

  const blockMenu = [
    {
      id: 100,
      name: "Información general",
      icon: <LuInfo />,
      content: <GeneralInformation />,
    },
    {
      id: 101,
      name: "Usuarios y permisos",
      icon: <LuUsers />,
      content: <UsersAndPermissions />,
    },
    {
      id: 102,
      name: "Métodos de pago",
      icon: <LuCreditCard />,
      content: <PaymentsMethods />,
    },
    {
      id: 103,
      name: "Métodos de entrega y envío",
      icon: <LuTruck />,
      content: <DeliveryMethods />,
    },
    {
      id: 104,
      name: "Plataformas",
      icon: <LuGlobe />,
      content: <Domains />,
    },
    {
      id: 105,
      name: "Políticas",
      icon: <LuFileText />,
      content: <Policies />,
    },
    {
      id: 107,
      name: "Impresoras",
      icon: <LuPrinter />,
      content: <Printers />,
    },
    {
      id: 108,
      name: "Diseño",
      icon: <LuPalette />,
      content: <Design />,
    },
    {
      id: 110,
      name: "Gestor de pedidos",
      icon: <LuChefHat />,
      content: <PointInvoice />,
    },
    {
      id: 111,
      name: "Configuración avanzada",
      icon: <LuSettings />,
      content: <AdvancedConfiguration />,
    },
    {
      id: 112,
      name: "Facturación",
      icon: <LuReceiptText />,
      content: <BillingSettings />,
    },
    {
      id: 113,
      name: "Horarios",
      icon: <LuClock />,
      content: <Schedule />,
    },
  ];

  const descriptions = {
    100: "Identidad fiscal, contacto, propietario y moneda del negocio.",
    101: "Usuarios, roles, plataformas y acceso personal con PIN.",
    102: "Métodos predefinidos y manuales que admite tu negocio.",
    103: "Recogida, envío a domicilio y condiciones de entrega.",
    104: "Accesos a las plataformas.",
    105: "Textos legales y políticas visibles para tus clientes.",
    107: "Impresoras del negocio, su dirección IP y el perfil al que están asociadas.",
    108: "Logos, color de marca y aspecto de la tienda online.",
    110: "Perfiles de cocina, canales y tiempos de preparación y entrega.",
    111: "Tiempo para considerar un carrito como abandonado.",
    112: "Estado de facturación y prefijos de numeración.",
    113: "Franjas semanales y horarios personalizados del negocio.",
  };
  const menuOrder = [
    100, 101, 108, 102, 112, 103, 104, 110, 107, 105, 113, 111,
  ];
  const normalized = (value) =>
    value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  const visibleMenu = menuOrder
    .map((id) => blockMenu.find((option) => option.id === id))
    .filter((option) =>
      normalized(`${option.name} ${descriptions[option.id]}`).includes(
        normalized(search),
      ),
    );
  const selected = blockMenu.find((option) => option.id === selectedButton);
  const MenuDesign = ({ block }) => {
    return block?.map((option) => {
      const activeStyle =
        option.id === selectedButton ? " optionMenuActive " : "";
      return (
        <button
          key={option.id}
          type="button"
          aria-label={option.name}
          aria-current={option.id === selectedButton ? "page" : undefined}
          onClick={() => handleMenu(option)}
          className={"configurationMenu " + activeStyle}
        >
          <div className="configurationMenuIcon">{option.icon}</div>
          <div className="configurationMenuText">{option.name}</div>
        </button>
      );
    });
  };

  useEffect(() => {
    const sync = () => {
      setLegacyTerminalLink(window.location.hash === "#109");
      const option =
        blockMenu.find(
          (item) => item.id === Number(window.location.hash.slice(1)),
        ) || blockMenu[0];
      setSelectedButton(option.id);
      setContent(option.content);
    };
    sync();
    window.addEventListener("hashchange", sync);
    return () => window.removeEventListener("hashchange", sync);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="configurationReference">
      <div className="topContainer">
        <div className="pageHeading">
          <h1 className="bodyTitle">Configuración</h1>
          <p>
            Ajustes del negocio, la tienda, el TPV, los pagos y la seguridad del
            panel.
          </p>
        </div>
        <div className="actionsDashboard"></div>
      </div>

      <div className="configurationLayout">
        <div className="configurationPanel">
          <label className="configurationMobileSelect">
            Sección de configuración
            <select
              value={selectedButton}
              onChange={(event) =>
                handleMenu(
                  blockMenu.find(
                    (option) => option.id === Number(event.target.value),
                  ),
                )
              }
            >
              {blockMenu.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
          </label>
          <div className="row mb-3">
            <div className="col-12" style={{ padding: "0" }}>
              <div className="adminPanel ">
                <label className="settingsSearch settingsMobileSearch">
                  <FiSearch aria-hidden="true" />
                  <input
                    type="search"
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                    placeholder="Buscar en configuración…"
                    aria-label="Buscar en configuración"
                  />
                </label>
                <nav aria-label="Secciones de configuración">
                  <MenuDesign block={visibleMenu} />
                </nav>
                {!visibleMenu.length && <p>No hay ajustes con ese nombre.</p>}
              </div>
            </div>
          </div>
        </div>
        <div className="configurationContent">
          {legacyTerminalLink && (
            <p role="status">
              La configuración de terminales y usuarios se ha trasladado a{" "}
              <Link to="/salesChannel">
                Canal de venta → ficha del canal TPV → Terminales
              </Link>
              .
            </p>
          )}
          <div className="row mb-3">
            <div className="col-12">
              {selectedButton !== 100 && selectedButton !== 101 && selectedButton !== 104 && (
                <header className="settingsSectionHeader">
                  <h2>{selected?.name}</h2>
                  <p>{descriptions[selectedButton]}</p>
                </header>
              )}
              {content}
              {selectedButton !== 104 && <nav
                className="settingsRelated"
                aria-label="Ajustes relacionados"
              >
                {(selectedButton === 110
                  ? [101, 113, 107]
                  : selectedButton === 100
                    ? [108, 113, 112]
                    : selectedButton === 102
                      ? [103, 112]
                      : [100, 104]
                )
                  .filter((id) => id !== selectedButton)
                  .map((id) => {
                    const option = blockMenu.find((item) => item.id === id);
                    return (
                      <button
                        type="button"
                        key={id}
                        onClick={() => handleMenu(option)}
                      >
                        {option.name}
                        <FiArrowRight aria-hidden="true" />
                      </button>
                    );
                  })}
              </nav>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
